import * as t from './actionTypes';
import * as constants from './constants';
import { isEmpty, find, filter } from 'lodash';
import { message } from 'antd';

import common from '../../common';
import globalappstate from '../globalappstate';
import uistate from '../uistate';

export function loadUsersWithLocalAppRights(forceRefresh) {
    return async (dispatch, getState) => {
        const localstate = getState()[constants.NAME];
        if (forceRefresh || isEmpty(localstate.localAppUsers)) {
            const resp = await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/management/appusers`);
            dispatch({
                type: t.LOAD_LOCAL_APP_USERS,
                payload: resp.data
            })
        }
    };
}
export function clearServerRightsCache() {
    return function (dispatch) {
        common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/management/clearrightscache`);
    };
}


export function setSelectedLocalAppUser(id) {
    return async (dispatch, getState) => {
        dispatch({
            type: t.SET_SELECTED_LOCAL_APP_USER,
            payload: id
        });
        const resp = await common.managementApiClient.get(`${common.SETTINGS.REMOTERESOURCES.MANAGEMENTAPI.ROOT_URL}/api/userroles/${common.APP_CONSTANTS.LocalAppId}/user/${id}`);
        const payload = filter(resp.data, function (r) {
            return r.securableEntityId == common.APP_CONSTANTS.SecurableEntityIdForCompany
        });
        dispatch({
            type: t.LOCAL_APPROLES_LOADED,
            payload: payload
        })
    };
}
export function addSelectedUserToLocalList(iduser) {
    return function (dispatch, getState) {
        let users = globalappstate.selectors.allUsers(getState());
        let selecteduser = find(users, { 'idUser': iduser });
        dispatch({
            type: t.ADD_LOCAL_APP_USER,
            payload: selecteduser
        });
    };
}
export function loadLocalEntities() {
    return async (dispatch, getState) => {
        const resp = await common.managementApiClient.get(`${common.SETTINGS.REMOTERESOURCES.MANAGEMENTAPI.ROOT_URL}/api/securableentities/${common.APP_CONSTANTS.LocalAppId}`);
        dispatch({
            type: t.LOCAL_APPENTITIES_LOADED,
            payload: resp.data
        })
    };
}
export function setSelectedLocalUserRole(roleid) {
    return async (dispatch, getState) => {
        const localstate = getState()[constants.NAME];
        const selectedLocalAppUserId = localstate.selectedLocalAppUserId;
        const resp = await common.managementApiClient.get(`${common.SETTINGS.REMOTERESOURCES.MANAGEMENTAPI.ROOT_URL}/api/userroles/${common.APP_CONSTANTS.LocalAppId}/${roleid}/${selectedLocalAppUserId}`);
        dispatch({
            type: t.LOCAL_USER_ROLE_DETAILS_LOADED,
            payload: resp.data
        })
    };
}
export function updateSelectedLocalUserRoleActive(isActive) {
    return function (dispatch) {
        dispatch({
            type: t.SET_SELECTED_LOCAL_USER_ROLE_ACTIVE,
            payload: isActive
        });
    };
}
export function updateSelectedLocalUserRoleGlobal(isGlobal) {
    return function (dispatch) {
        dispatch({
            type: t.SET_SELECTED_LOCAL_USER_ROLE_GLOBAL,
            payload: isGlobal
        });
    };
}
export function updateSelectedLocalSecurableEntityHierarchy(isActive, entityId) {
    return function (dispatch, getState) {
        const localstate = getState()[constants.NAME];
        const localSecurableEntityId = find(localstate.localAppEntities, ['keyName', 'Hierarchy']).idSecurableEntity;
        const new_securableentity = {
            entityId,
            active: isActive,
            inherit: false,
            securableEntityId: localSecurableEntityId
        }
        console.log(new_securableentity);
        dispatch({
            type: t.SET_SELECTED_LOCAL_USER_ROLE_SECURABLE_ENTITY_ACTIVE,
            payload: new_securableentity
        });
    };
}
export function saveSelectedUserRoleDetails() {
    return async (dispatch, getState) => {
        const labels = uistate.selectors.uiLabels(getState());
        const localstate = getState()[constants.NAME];
        const selectedUserRoleDetails = localstate.selectedUserRoleDetails;
        await common.managementApiClient.put(`${common.SETTINGS.REMOTERESOURCES.MANAGEMENTAPI.ROOT_URL}/api/userroles/${common.APP_CONSTANTS.LocalAppId}/${selectedUserRoleDetails.userRole.idUserRole}`, selectedUserRoleDetails);
        message.success(labels[constants.NAME]['RoleSaved']);
    };
}
export function reloadAppRolesForCurrentUser() {
    return async (dispatch, getState) => {
        const localstate = getState()[constants.NAME];
        const selectedLocalAppUserId = localstate.selectedLocalAppUserId;
        const resp = await common.managementApiClient.get(`${common.SETTINGS.REMOTERESOURCES.MANAGEMENTAPI.ROOT_URL}/api/userroles/${common.APP_CONSTANTS.LocalAppId}/user/${selectedLocalAppUserId}`);
        const payload = filter(resp.data, function (r) {
            return r.securableEntityId == common.APP_CONSTANTS.SecurableEntityIdForCompany
        });
        dispatch({
            type: t.LOCAL_APPROLES_LOADED,
            payload: payload
        })
    };
}
export function updateSelectedLocalSecurableEntityCompany(isActive, entityId) {
    return function (dispatch, getState) {
        const localstate = getState()[constants.NAME];
        const localSecurableEntityId = find(localstate.localAppEntities, ['keyName', 'Company']).idSecurableEntity;
        const new_securableentity = {
            entityId,
            active: isActive,
            inherit: false,
            securableEntityId: localSecurableEntityId
        }
        dispatch({
            type: t.SET_SELECTED_LOCAL_USER_ROLE_SECURABLE_ENTITY_ACTIVE,
            payload: new_securableentity
        });
    };
}
export function updateSelectedLocalSecurableEntityCompanyInherit(inherit, entityId) {
    return function (dispatch, getState) {
        const localstate = getState()[constants.NAME];
        let securableEntity = find(localstate.selectedUserRoleDetails.securableEntities, ['entityId', entityId]);
        if (!isEmpty(securableEntity)) {
            securableEntity.inherit = inherit;
            dispatch({
                type: t.SET_SELECTED_LOCAL_USER_ROLE_SECURABLE_ENTITY_INHERIT,
                payload: securableEntity
            });
        }
    };
}

export function loadAppResource(lang, resourcekey) {
    return async (dispatch, getState) => {
        return await common.apiClient.get(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/AppResource/${resourcekey}/${lang}`);
    };
}
export function saveAppResource(lang, resourcekey, appresource) {
    return async (dispatch, getState) => {
        const labels = uistate.selectors.uiLabels(getState());
        const localstate = getState()[constants.NAME];
        const selectedUserRoleDetails = localstate.selectedUserRoleDetails;
        await common.apiClient.put(`${common.SETTINGS.REMOTERESOURCES.API.ROOT_URL}/api/AppResource/${resourcekey}/${lang}`, appresource);
        message.success("Saved");
    };
}
